module.exports = __webpack_public_path__ + "static/media/1POLICY33.dd5b109e.jpg";